import Bill from './components/bill';
import Carousel from './components/carousel';
import Expandable from './components/expandable';
// import FormValidator from './components/form-validator';
import Navigation from './components/navigation';
import Paypal from './components/paypal';
import TabBar from './components/tab-bar';
import Toc from './components/toc';

// initialize components
Bill.enhance();
Carousel.enhance();
Expandable.enhanceAll();
//FormValidator.enhance();
Navigation.enhance();
Paypal.enhance();
TabBar.enhance();
Toc.enhance();

// jQuery related
let $ = window.jQuery;

$(() => {
    // Datepicker
    $('[data-mt-datepicker]').datepicker({
        dateFormat: 'yy-mm-dd',
    });
});
